import { motion } from "framer-motion";
import { ShoppingCart, Heart, HardHat, Factory, Tractor, Building2 } from "lucide-react";

const industries = [
  {
    icon: ShoppingCart,
    title: "Retail & Restaurants",
    description: "Uninterrupted POS operations"
  },
  {
    icon: Heart,
    title: "Healthcare Facilities",
    description: "Compliant, reliable connectivity"
  },
  {
    icon: HardHat,
    title: "Construction & Field Sites",
    description: "Rapid deployment anywhere"
  },
  {
    icon: Factory,
    title: "Manufacturing & Industrial",
    description: "Real-time monitoring & control"
  },
  {
    icon: Tractor,
    title: "Agriculture & Farming",
    description: "IoT sensors and precision agriculture"
  },
  {
    icon: Building2,
    title: "Government & Municipal",
    description: "Secure infrastructure connectivity"
  }
];

export const HomeIndustries = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Trusted by Businesses Across Every Industry
          </h2>
          <p className="text-xl text-muted-foreground max-w-4xl mx-auto">
            From retail to healthcare, construction to agriculture—SimNet delivers connectivity solutions for mission-critical operations
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-8 rounded-xl hover:shadow-xl transition-all group cursor-pointer"
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors group-hover:scale-110 duration-300">
                <industry.icon className="w-8 h-8 text-primary" />
              </div>

              <h3 className="text-xl font-bold mb-2">{industry.title}</h3>
              <p className="text-muted-foreground">{industry.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
